import React from "react";
import "./contactUs.css";
import Particles from "../Particles/Particles";
import HeroSection from "./HeroSection";
import ContactForm from "./ContactForm";
import InvitePage from "./InvitePage";

const ContactUs = () => {
  return (
    <div className="contact-page-wrapper">
      <Particles title="Contact Us" subTitle="Feel free to contact us." />
      <HeroSection />
      <ContactForm />
      <InvitePage />
    </div>
  );
};

export default ContactUs;
